
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Slide } from "react-toastify";
import PrivateRoute from "./Pages/utils/PrivateRoute";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Suspense, lazy, useContext, useEffect, useState } from "react";
import {
  Apiurl,
  GetLocalStorageParsed,
  parseData,
  SetLocalStorageStringify,
} from "./Pages/utils/page";
import RoleBasedRoute from "./Pages/utils/RoleBasedRoute";
import { UserContext } from "./UserContext";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import { Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import LoginModal from "./Components/LoginModal/LoginModal";
import { jwtDecode } from "jwt-decode";
import { useGoogleLogin } from "@react-oauth/google";
import SpinnerWheel from "./Components/AdminComponent/WheelSlabComponent/SpinnerWheel";

import { ProfileContext } from "./Context/ProfileContext";
import { AuthContext } from "./Context/AuthContext";
import { FaHeart } from "react-icons/fa6";

import CookieConsent from "./Common/CookieConsent/CookieConsent";
import ExitIntentPopup from "./Common/ExitIntent/ExitIntentPopup";
import './App.css'
import './Components/Header/Style.css'
import './Common/CommonProductCard/CommonProductCard.css'
import 'leaflet/dist/leaflet.css';


// Eagerly loading critical CSS to prevent layout shifts/specificity issues with React.lazy
import './Pages/Home/Home.css'
import './Pages/ActiveBids/ActiveBids.css'
import './Pages/Blogs/Blogs.css'
import './Pages/DashboardTest/DashboardTest.css'
import './Pages/EventsCampaign/EventsCampaign.css'
import './Pages/FestivalProducts/FestivalProducts.css'
import './Pages/FestivalWinnerGift/FestivalWinnerGift.css'
import './Pages/SellerHomePage/SellerHomePage.css'
import './Pages/Unauthorized/Unauthorized.css'
import './Pages/page.module.css'
import './Components/CartDetailsComponent/CartDetailsComponent.css'
import './Components/OrderComponents/Order.css'
import './Common/CommonProductCard/CommonProductCard.css'
import './Common/CartWheel.css'
import './Common/Profile/NewProfile.css'
import './Common/NewCart/NewCart.css'
import './Components/AdminComponent/AddRewardsComponent/AddRewardsComponent.css'
import './Components/AdminComponent/AddEventComponent/AddEventComponent.css'
import './Components/ProfileComponent/ProfileComponent.css'
import './Components/FilterPageComponent/FilterPageComponent.css'
import './Components/AdminComponent/AddPromotionalBannerComponent/AddPromotionalBannerComponent.css'
import './Components/Loader/Loader.css'
import './Common/ContactNew/ContactNew.css'
import './Components/PromotionalBannerDetailComponent/PromotionalBannerDetailComponent.css'
import './Components/OurExclusivePartner/OurExclusivePartner.css'
import './Pagination/Pagination.css';
import "react-quill/dist/quill.snow.css";



import { PiSpinnerBallBold } from "react-icons/pi";
import Loader from "./Components/Loader/Loader";

const Home = lazy(() => import("./Pages/Home/Home"));
const CartDetails = lazy(() => import("./Pages/CartDetails/CartDetails"));
const ContactUs = lazy(() => import("./Pages/ContactUs/ContactUs"));
const Howitswork = lazy(() => import("./Pages/Howitswork/Howitswork"));
const Orders = lazy(() => import("./Pages/Orders/Orders"));
const PaymentFailed = lazy(() => import("./Pages/PaymentFailed/PaymentFailed"));
const PaymentSuccess = lazy(() => import("./Pages/PaymentSuccess/PaymentSuccess"));
const PrivacyPolicy = lazy(() => import("./Pages/PrivacyPolicy/PrivacyPolicy"));
const ProductDetail = lazy(() => import("./Pages/ProductDetail/ProductDetail"));
const Profile = lazy(() => import("./Pages/Profile/Profile"));
const ReferralCode = lazy(() => import("./Pages/ReferralCode/ReferralCode"));
const TermsAndConditons = lazy(() => import("./Pages/TermsAndConditons/TermsAndConditons"));
const VendorProductsDetail = lazy(() => import("./Pages/VendorProductDetail/VendorProductDetail"));
const FestivalProducts = lazy(() => import("./Pages/FestivalProducts/FestivalProducts"));
const FestivalWinnerGift = lazy(() => import("./Pages/FestivalWinnerGift/FestivalWinnerGift"));
const UploadAndListing = lazy(() => import("./Pages/UploadAndListing/UploadAndListing"));
const BannerAnalytic = lazy(() => import("./Pages/BannerAnalytic/BannerAnalytic"));
const CustomerQueries = lazy(() => import("./Pages/CustomerQueries/CustomerQueries"));
const PromotionalBannerQueryList = lazy(() => import("./Pages/PromotionalBannerQueryList/PromotionalBannerQueryList"));
const CustomerOrders = lazy(() => import("./Pages/CustomerOrders/CustomerOrders"));
const Blogs = lazy(() => import("./Pages/Blogs/Blogs"));
const AddPoints = lazy(() => import("./Pages/AdminPages/AddPoints/AddPoints"));
const BlogsReadMore = lazy(() => import("./Components/BlogsComponent/BlogsReadMore"));
const DefaultSetting = lazy(() => import("./Pages/AdminPages/DefaultSetting/DefaultSetting"));
const PromoCode = lazy(() => import("./Pages/AdminPages/PromoCode/PromoCode"));
const AddBlogs = lazy(() => import("./Pages/AdminPages/AddBlogs/AddBlogs"));
const AddEvents = lazy(() => import("./Pages/AdminPages/AddEvents/AddEvents"));
const AddPromotionalBanner = lazy(() => import("./Pages/AdminPages/AddPromotionalBanner/AddPromotionalBanner"));
const AddRewards = lazy(() => import("./Pages/AdminPages/AddRewards/AddRewards"));
const AssignRoles = lazy(() => import("./Pages/AdminPages/AssignRoles/AssignRoles"));
const AffiliatePartnerRequest = lazy(() => import("./Pages/AdminPages/AffiliatePartnerRequest/AffiliatePartnerRequest"));
const AllItems = lazy(() => import("./Pages/AdminPages/AllItems/AllItems"));
const AssignUsersToManager = lazy(() => import("./Pages/AdminPages/AssignUsersToManager/AssignUsersToManager"));
const AllTransactions = lazy(() => import("./Pages/AdminPages/AllTransactions/AllTransactions"));
const ContactUsQueries = lazy(() => import("./Pages/AdminPages/ContactUsQueries/ContactUsQueries"));
const WinnerStatus = lazy(() => import("./Pages/AdminPages/WinnerStatus/WinnerStatus"));
const LandingPage = lazy(() => import("./Pages/LandingPage/LandingPage"));
const PromotionalBannerDetail = lazy(() => import("./Pages/PromotionalBannerDetail/PromotionalBannerDetail"));
const FilterPage = lazy(() => import("./Pages/FilterPage/FilterPage"));
const Manager = lazy(() => import("./Pages/AdminPages/Manager/Manager"));
const Checkout = lazy(() => import("./Pages/Checkout/Checkout"));
const NotFound = lazy(() => import("./Pages/NotFound"));
const AddPickupLocation = lazy(() => import("./Pages/AdminPages/AddPickupLocation/AddPickupLocation"));
const AllUsers = lazy(() => import("./Pages/AdminPages/AllUsers/AllUsers"));
const Unauthorized = lazy(() => import("./Pages/Unauthorized/Unauthorized"));
const RaiseQuery = lazy(() => import("./Pages/RaiseQuery/RaiseQuery"));
const ManageWheelSlab = lazy(() => import("./Pages/AdminPages/WheelSlab/ManageWheelSlab"));
const AddBlogsCategory = lazy(() => import("./Pages/AdminPages/AddBlogsCategory/AddBlogsCategory"));
const VendorTermsAndCondition = lazy(() => import("./Pages/AdminPages/VendorTermsAndCondition/VendorTermsAndCondition"));
const Tax = lazy(() => import("./Pages/AdminPages/Tax/Tax"));
const ProductCategory = lazy(() => import("./Pages/AdminPages/ProductCategory/ProductCategory"));
const ThirdPartyApi = lazy(() => import("./Pages/AdminPages/ThirdPartyApi/ThirdPartyApi"));
const AboutUs = lazy(() => import("./Pages/AdminPages/AboutUs/AboutUs"));
const AboutUsHome = lazy(() => import("./Pages/AboutUsHome/AboutUsHome"));
const Campaign = lazy(() => import("./Pages/AdminPages/Campaign/Campaign"));
const CampaignLive = lazy(() => import("./Pages/CampaignLive/CampaignLive"));
const AllSellerListing = lazy(() => import("./Pages/AllSellerListing/AllSellerListing"));
const AddCompanyCodes = lazy(() => import("./Pages/AdminPages/AddCompanyCodes/AddCompanyCodes"));
const FeatureBestSellerAdmin = lazy(() => import("./Pages/AdminPages/FeatureBestSellerAdmin/FeatureBestSellerAdmin"));
const AddTestimonial = lazy(() => import("./Pages/AdminPages/AddTestimonial/AddTestimonial"));
const Testimonial = lazy(() => import("./Pages/Testimonial/Testimonial"));
const AddAnnouncement = lazy(() => import("./Pages/AdminPages/AddAnnouncement/AddAnnouncement"));
const AdminSales = lazy(() => import("./Pages/AdminPages/AdminSales/AdminSales"));
const AddReturnReason = lazy(() => import("./Pages/AdminPages/AddReturnReason/AddReturnReason"));
const DiscountSpinReward = lazy(() => import("./Pages/AdminPages/DiscountSpinReward/DiscountSpinReward"));
const SalesProducts = lazy(() => import("./Pages/SalesProducts/SalesProducts"));
const EventsCampaign = lazy(() => import("./Pages/EventsCampaign/EventsCampaign"));
const Logs = lazy(() => import("./Pages/AdminPages/Logs/Logs"));
const AddProductReview = lazy(() => import("./Pages/AdminPages/AddProductReviews/AddProductReview"));
const ProductSubCategory = lazy(() => import("./Pages/AdminPages/ProductSubCategory/ProductSubCategory"));
const ActiveBids = lazy(() => import("./Pages/ActiveBids/ActiveBids"));
const Winning = lazy(() => import("./Pages/Winning/Winning"));
const DashboardTest = lazy(() => import("./Pages/DashboardTest/DashboardTest"));
const SellerHomePage = lazy(() => import("./Pages/SellerHomePage/SellerHomePage"));

function App() {
  useEffect(() => {
    if (window.location.hostname === "www.shopsaverz.com") {
      window.location.href =
        "https://shopsaverz.com" +
        window.location.pathname +
        window.location.search;
    }
  }, []);

  const [loginTrigger, setLoginTrigger] = useState(false);
  const { roles } = useContext(UserContext);

  const offlineToastId = "offline-toast";


  const updateNetworkStatus = () => {
    const status = navigator.onLine;

    if (!status) {
      toast.error(
        "⚠️ You are currently offline. Please check your internet connection.",
        {
          toastId: offlineToastId,
          autoClose: false,
          closeButton: false,
          draggable: false,
          position: "top-center",
          style: {
            background: "#2f2f2f",
            color: "#f0f0f0",
            fontWeight: 500,
            borderRadius: "8px",
            padding: "16px",
            boxShadow: "0 2px 12px rgba(0, 0, 0, 0.2)",
          },
          icon: false,
        }
      );
    } else {
      toast.dismiss(offlineToastId);
    }
  };

  useEffect(() => {
    window.addEventListener("load", updateNetworkStatus);
    window.addEventListener("online", updateNetworkStatus);
    window.addEventListener("offline", updateNetworkStatus);

    return () => {
      window.removeEventListener("load", updateNetworkStatus);
      window.removeEventListener("online", updateNetworkStatus);
      window.removeEventListener("offline", updateNetworkStatus);
    };
  }, [navigator.onLine]);

  const router = useNavigate();
  const FetchToken = GetLocalStorageParsed("AuthToken");

  const [loading, setLoading] = useState("");
  const [loginToken, setLoginToken] = useState(FetchToken || null);
  const updateToken = (token) => {
    setLoginToken(token);

    if (token) {
      localStorage.setItem("AuthToken", JSON.stringify(token));
    } else {
      localStorage.removeItem("AuthToken");
    }
  };

  const [spinerStatus, setSpinerStatus] = useState();
  const [showSpinnerModal, setshowSpinnerModal] = useState(false);
  const [allExpiredCampaign, setAllExpiredCampaign] = useState();
  const [showCampaignLiveModal, setShowCampaignLiveModal] = useState(false);

  const [activeCampaign, setActiveCampaign] = useState();
  const [showLoginTrue, setShowLoginTrue] = useState();
  const [redirectAfterLogin, setRedirectAfterLogin] = useState(null);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const GetActiveCampaign = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken}`,
      },
      url: `${Apiurl()}/api/UserPointsEvent/GetActivePointsCampaign`,
    };
    axios(option)
      .then((e) => {
        setActiveCampaign(parseData(e?.data?.result));
      })
      .catch((error) => {});
  };
   const GetAllExpiredCampaign = () => {
      const option = {
        method: "GET",
        headers: {
          accept: "*/*",
          Authorization: `Bearer ${loginToken}`,
        },
        url: `${Apiurl()}/api/UserPointsEvent/GetAllLatestExpiredPointsCampaign`,
      };
      axios(option)
        .then((e) => {

          setAllExpiredCampaign(parseData(e?.data?.result));
        })
        .catch((error) => {});
    };

  useEffect(() => {
    GetActiveCampaign();
    GetAllExpiredCampaign();
  }, []);
  const getProfile = (token) => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${token || loginToken || " "}`,
      },
      url: `${Apiurl()}/api/Customer/UserInfo`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setProfileData(data);
        SetLocalStorageStringify("ProfileData", data);
        if (redirectAfterLogin) {
          router(redirectAfterLogin);
          setRedirectAfterLogin(null); // clear it
        }
      })
      .catch((error) => {});
  };
  const handleClose = () => {
    setShowLoginModal(false);
  };


  const [spinerAddedData, setSpinerAddedData] = useState();
  const [profileData, setProfileData] = useState(
    GetLocalStorageParsed("ProfileData") || []
  );
  const [pointsClaimed, setPointsClaimed] = useState(false);

  const handleOpenSpinnerModal = () => {
    setshowSpinnerModal(true);
  };

  const getSaveSpinReward = () => {
    setLoading("spin");
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      url: `${Apiurl()}/api/Games/GetAllSpinRewards`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setSpinerAddedData(data);
        handleOpenSpinnerModal();
        setLoading("");
      })
      .catch((error) => {});
  };

  const getSpinWheelStatus = () => {
    const option = {
      method: "POST",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      url: `${Apiurl()}/api/Games/GetSpinQuotaStatus`,
    };
    axios(option)
      .then((e) => {
        const data = e?.data?.result;
        setSpinerStatus(data);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
      });
  };
  const loginApi = (userDetail) => {
    const data = {};
    data.email = userDetail?.email;
    data.name = userDetail?.name;
    data.image = "";
    const options = {
      method: "POST",
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
      },
      data: JSON.stringify(data),
      url: `${Apiurl()}/api/UserAccount/UserLogin`,
    };
    axios(options)
      .then((data) => {
        const token = parseData(data?.data?.result);
        const user = jwtDecode(token?.Token);
        SetLocalStorageStringify("UserDetail", JSON.stringify(token));

        SetLocalStorageStringify("User", JSON.stringify(user));

        SetLocalStorageStringify("AuthToken", token?.Token);

        setShowLoginTrue(token?.Token);


        getProfile(token?.Token);

        handleClose();
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
      });
  };
  const handleLogin = useGoogleLogin({
    onSuccess: async ({ access_token }) => {
      const userInfo = await axios.get(
        "https://www.googleapis.com/oauth2/v3/userinfo",
        { headers: { Authorization: `Bearer ${access_token}` } }
      );
      loginApi(userInfo?.data);
      // SetLocalStorageStringify("googleData", userInfo?.data)
    },
  });
  const handleSpinPointTest = async () => {
    const data = {  
      id: "00000000-0000-0000-0000-000000000000",
      isActive: false,
    };
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: JSON.stringify(data),
      url: `${Apiurl()}/api/Games/SpinWheel`,
      // Games/TestSpinWheel
    };
    try {
      const res = await axios(option);
      const result = res.data.result;
      if (result?.points != null || result?.cashAmount != null) {
        getSpinWheelStatus();
        return result;
      }
    } catch (res) {
      toast.error(res?.response?.data?.message);
      return null;
    }
  };
  const handleCloseSpinnerClaim = () => {
    setPointsClaimed(false);
    getSpinWheelStatus();
  };
  const handleCloseSpinnerModal = () => {
    setshowSpinnerModal(false);
  };

  const [isMobileScreen, setIsMobileScreen] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobileScreen(window.innerWidth >= 320 && window.innerWidth <= 767);
    };

    // Initial check
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Clean up event listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [isSignup, setIsSignup] = useState(false);

const [signupData, setSignupData] = useState({
  name: "",
  email: "",
  phone: "",
  emailOtp: "",
  phoneOtp: "",
});








  return (
    <AuthContext.Provider value={{ loginToken, updateToken }}>
      <ProfileContext.Provider
        value={{ globalProfile: profileData, setGlobalProfile: setProfileData }}
      >
        <div style={{ position: "relative" }}>
        

          {loginToken && (
            <p
              className="click_me_btn-spinner"
              id="spinner-wheel-discription"
              onClick={() => {
                if (loading === "spin") {
                  return;
                }
                getSaveSpinReward();
                getSpinWheelStatus();
              }}
            >
              {loading === "spin" ? (
                <ClipLoader loading size={15} />
              ) : (
                <>
                 
                  <div className="spin-new-icon-main small">
    <PiSpinnerBallBold className="Spin-new-icon-react"/> Spin
  </div>
                </>
              )}
            </p>
          )}

          {activeCampaign  ? (
            <>
              {isMobileScreen ? (
                <FaHeart 

                  onClick={() => {
                    setShowCampaignLiveModal(true);
                  }}
                  className="click_me_btn-campaign-icon"
                />
              ) : (
                <p
                  className="click_me_btn-campaign"
                  id="spinner-wheel-discription"
                

                  onClick={() => {
                    setShowCampaignLiveModal(true);
                  }}
                >
                  {activeCampaign?.EventName}
                </p>
              )}
            </>
          ) : null}

          <LoginModal
            showLoginModal={showLoginModal}
            setShowLoginModal={setShowLoginModal}
            handleClose={handleClose}
            handleLogin={handleLogin}

            isSignup={isSignup}
            signupData={signupData}
            setSignupData={setSignupData  }
            setIsSignup={setIsSignup}
          />
          <Modal
            show={showCampaignLiveModal}
            onHide={() => setShowCampaignLiveModal(false)}
            backdrop="static"
            centered
            className="custom-campaign-modal"
          >
            <div className="campaign-modal-container">
              {activeCampaign ? (
                <>
                  <div className="campaign-modal-header">
                    <h4>{activeCampaign?.EventName}</h4>
                    <button
                      className="campaign-close-btn"
                      onClick={() => setShowCampaignLiveModal(false)}
                    >
                      ✕
                    </button>
                  </div>

                  <div className="campaign-modal-body">
                    <div className="campaign-image-wrapper">
                      <img
                        // src={`${Apiurl()}/${activeCampaign?.EventImage.replace(
                        //   /"/g,
                        //   ""
                        // )}`}
  src={`${Apiurl()}/${activeCampaign?.EventImage?.replace(/"/g, "")}`}
                        alt={activeCampaign?.EventName}
                        className="campaign-image"
                      />
                    </div>

                   
                  </div>
                  <button
                    type="button"
                    className="common_btn claim_rew_pd w-100 campaign-more-det"
                    onClick={() => {
                      if (loginToken || showLoginTrue) {
                        setShowCampaignLiveModal(false);
                        // router(`/campaign/${activeCampaign?.EventNameLink}`);
                        router("/events");
                      } else {
                        setRedirectAfterLogin(
                          "/events"
                        );
                        // setRedirectAfterLogin(
                        //   `/campaign/${activeCampaign?.EventNameLink}`
                        // );
                        setShowCampaignLiveModal(false);
                        toast.error("Please login first");
                        // handleShow();
                      }
                    }}
                  >
                    More Details
                  </button>
                </>
              ) : (
                <div className="expired-campaign-list">
                  <div className="campaign-modal-header">
                    <h4 className="expired-heading">Expired Campaigns</h4>
                    <button
                      className="campaign-close-btn"
                      onClick={() => setShowCampaignLiveModal(false)}
                    >
                      ✕
                    </button>
                  </div>
                  {allExpiredCampaign?.map((i) => (
                    <div
                      key={i?.Id}
                      className="expired-campaign-item"
                      onClick={() => {
                       if (loginToken || showLoginTrue) {
                        setShowCampaignLiveModal(false);
                        router(`/campaign/${i?.EventNameLink}`);
                        // router(`/campaign/${i?.EventNameLink}`)
                      } else {
                        setRedirectAfterLogin(
                          `/campaign/${i?.EventNameLink}`
                        );
                        setShowCampaignLiveModal(false);
                        toast.error("Please login first");
                        // handleShow();
                      }
                      }}
                    >
                      <span className="expired-campaign-title">
                        {i?.EventName}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </Modal>
          <Modal
            show={showSpinnerModal}
            backdrop="static"
            centered
            contentClassName="no-header-footer-modal"
          >
            <Modal.Body className="spinner-modal-body">
              <div>
                <SpinnerWheel
                  spinerAddedData={spinerAddedData}
                  handleSpinPointTest={handleSpinPointTest}
                  pointsClaimed={pointsClaimed}
                  handleCloseSpinnerClaim={handleCloseSpinnerClaim}
                  setPointsClaimed={setPointsClaimed}
                  handleCloseSpinnerModal={handleCloseSpinnerModal}
                  spinerStatus={spinerStatus}
                  getSaveSpinReward={getSaveSpinReward}
                  getProfile={getProfile}
                />
              </div>
            </Modal.Body>
          </Modal>
          <ToastContainer
            position="bottom-right"
            transition={Slide}
            autoClose={2000}
            closeOnClick
            theme="colored"
          />

            <Suspense fallback={<Loader />}>

            <Routes>
            <Route
              path="/"
              element={
                <Home
                  setLoginTrigger={setLoginTrigger}
                  loginTrigger={loginTrigger}
                />
              }
            />
            <Route path="/landing-page" element={<LandingPage />} />
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/raise-query" element={<RaiseQuery />} />
            <Route path="/how-it-works" element={<Howitswork />} />
            <Route path="/about-us" element={<AboutUsHome />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/bid-products" element={<FilterPage />} />
            <Route path="/buy-products" element={<FilterPage />} />
            <Route path="/all-products" element={<FilterPage />} />
            <Route path="/sales-products" element={<SalesProducts />} />
            <Route path="/referral-code/:code" element={<ReferralCode />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditons />} />
            <Route path="/winning" element={<Winning />} />
            <Route path="/become-a-seller" element={<SellerHomePage />} />
            <Route
              path="/festival-winners-gift"
              element={<FestivalWinnerGift />}
            />
      
  <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin","Manager","Vendor"]}
                    userRoles={roles}
                  >
                    <DashboardTest />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/cart-details"
              element={
                <PrivateRoute>
                  <CartDetails />
                </PrivateRoute>
              }
            />
            <Route
              path="/orders"
              element={
                <PrivateRoute>
                  <Orders />
                </PrivateRoute>
              }
            />
            <Route
              path="/payment-failed/:totalvalue"
              element={
                <PrivateRoute>
                  <PaymentFailed />
                </PrivateRoute>
              }
            />
            <Route
              path="/payment-success/:totalValue/:orderId"
              element={
                <PrivateRoute>
                  <PaymentSuccess />
                </PrivateRoute>
              }
            />
            <Route
              path="/:productDetailId/:productname/:userId/:platform"
              element={<ProductDetail />}
            />
            <Route path="/:product/:productname" element={<ProductDetail />} />

            <Route
              path="/promotional-banner-detail/:promotionalbannerdetail"
              element={<PromotionalBannerDetail />}
            />

            <Route
              path="/profile"
              element={
                <PrivateRoute>
                  <Profile />
                </PrivateRoute>
              }
            />
            
            <Route path="/category/:searchname" element={<FilterPage />} />
            <Route path="/seller/:name" element={<VendorProductsDetail />} />
            <Route
              path="/vendor-products-detail"
              element={<VendorProductsDetail />}
            />
          
            <Route
              path="/upload-and-listing"
              element={
                <PrivateRoute>
                  <UploadAndListing />
                </PrivateRoute>
              }
            />
            <Route
              path="/active-bids"
              element={
                <PrivateRoute>
                  <ActiveBids />
                </PrivateRoute>
              }
            />
            <Route
              path="/banner-analytic"
              element={
                <PrivateRoute>
                  <BannerAnalytic />
                </PrivateRoute>
              }
            />
            <Route
              path="/customer-queries"
              element={
                <PrivateRoute>
                  <CustomerQueries />
                </PrivateRoute>
              }
            />
            <Route
              path="/promotional-banner-query-list"
              element={
                <PrivateRoute>
                  <PromotionalBannerQueryList />
                </PrivateRoute>
              }
            />
            <Route
              path="/customer-orders"
              element={
                <PrivateRoute>
                  <CustomerOrders />
                </PrivateRoute>
              }
            />
            <Route
              path="/add-points"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <AddPoints />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/blogs"
              element={
                <Blogs />
              }
            />
            <Route
              path="/events"
              element={
                <EventsCampaign 
                allExpiredCampaign={allExpiredCampaign}
                />
              }
            />
            <Route
              path="/reviews"
              element={
                <Testimonial />
              }
            />
            <Route
              path="/all-sellers"
              element={
                <AllSellerListing />
              }
            />
            <Route
              path="/blogs/:id"
              element={
                <BlogsReadMore />
              }
            />
            <Route
              path="/third-party"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <ThirdPartyApi />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            
            <Route
              path="/default-settings"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["SuperAdmin"]}
                    userRoles={roles}
                  >
                    <DefaultSetting />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />

            <Route
              path="/manager"
              element={
                <PrivateRoute>
                  <RoleBasedRoute allowedRoles={["Manager"]} userRoles={roles}>
                    <Manager />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/promo-code"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <PromoCode />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/add-blogs"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <AddBlogs />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/add-events"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <AddEvents />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/add-promotional-banner"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <AddPromotionalBanner />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/add-rewards"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["SuperAdmin"]}
                    userRoles={roles}
                  >
                    <AddRewards />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/assign-roles"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <AssignRoles />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />

            <Route
              path="/affiliate-partner-request"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <AffiliatePartnerRequest />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/all-items"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["SuperAdmin"]}
                    userRoles={roles}
                  >
                    <AllItems />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/assign-users-to-manager"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <AssignUsersToManager />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/logs"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <Logs />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/all-transactions"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <AllTransactions />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/contact-us-queries"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <ContactUsQueries />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/winner-status"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <WinnerStatus />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/checkout"
              element={
                <PrivateRoute>
                  <Checkout />
                </PrivateRoute>
              }
            />
            <Route
              path="/pickup-location"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <AddPickupLocation />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/vendor-terms-and-conditions"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <VendorTermsAndCondition />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/tax"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <Tax />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/product-category"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <ProductCategory />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/product-sub-category"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <ProductSubCategory />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/about-us-admin"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <AboutUs />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/add-company-codes"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <AddCompanyCodes />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/add-testimonial"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <AddTestimonial />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/sales"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <AdminSales />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/add-announcement"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <AddAnnouncement />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/add-return-reason"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <AddReturnReason />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/discount-spin-reward"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <DiscountSpinReward />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/product-review"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <AddProductReview />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
          
            <Route
              path="/campaign"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <Campaign />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/featured-sellers-admin"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <FeatureBestSellerAdmin />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/all-users"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["SuperAdmin"]}
                    userRoles={roles}
                  >
                    <AllUsers />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/festival-products"
              element={
                <PrivateRoute>
                  <FestivalProducts />
                </PrivateRoute>
              }
            />
            <Route
              path="/campaign/:id"
              element={
                <PrivateRoute>
                  <CampaignLive />
                </PrivateRoute>
              }
            />
            <Route
              path="/wheel-slab"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <ManageWheelSlab />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/add-blogs-category"
              element={
                <PrivateRoute>
                  <RoleBasedRoute
                    allowedRoles={["Admin", "SuperAdmin"]}
                    userRoles={roles}
                  >
                    <AddBlogsCategory />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
          </Suspense>
          

          <CookieConsent />
          <ExitIntentPopup />
        </div>
      </ProfileContext.Provider>
    </AuthContext.Provider>
  );
}

export default App;
